// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".saving_indicator-layout {\n  display: flex;\n  flex-direction: column; }\n  .saving_indicator-layout .saving_indicator--icon {\n    display: flex;\n    align-items: center;\n    gap: 8px; }\n    .saving_indicator-layout .saving_indicator--icon .done-icon-indicator {\n      font-size: 1.3rem;\n      color: var(--accent); }\n    .saving_indicator-layout .saving_indicator--icon .failed-icon-indicator {\n      font-size: 1.3rem;\n      color: firebrick; }\n", ""]);
// Exports
module.exports = exports;
